
import Home from './Home'

export default {
  root: { path: '/', component: Home, name: 'root' },
  home: { path: '/home', component: Home, name: 'Home' },
}
